module.exports = __webpack_public_path__ + "static/media/slider1-1.2b7d8015.png";